/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bills": {
        "nested": {
          "CardData": {
            "fields": {
              "readerType": {
                "type": ".squareup.bills.CardData.ReaderType",
                "id": 1,
                "rule": "optional"
              },
              "keyedCard": {
                "type": ".squareup.bills.CardData.KeyedCard",
                "id": 2,
                "rule": "optional"
              },
              "unencryptedCard": {
                "type": ".squareup.bills.CardData.UnencryptedCard",
                "id": 3,
                "rule": "optional"
              },
              "o1Card": {
                "type": ".squareup.bills.CardData.O1Card",
                "id": 4,
                "rule": "optional"
              },
              "s1Card": {
                "type": ".squareup.bills.CardData.S1Card",
                "id": 5,
                "rule": "optional"
              },
              "r4Card": {
                "type": ".squareup.bills.CardData.R4Card",
                "id": 6,
                "rule": "optional"
              },
              "r6Card": {
                "type": ".squareup.bills.CardData.R6Card",
                "id": 7,
                "rule": "optional"
              },
              "encryptedKeyedCard": {
                "type": ".squareup.bills.CardData.EncryptedKeyedCard",
                "id": 8,
                "rule": "optional"
              },
              "a10Card": {
                "type": ".squareup.bills.CardData.A10Card",
                "id": 9,
                "rule": "optional"
              },
              "r12Card": {
                "type": ".squareup.bills.CardData.R12Card",
                "id": 10,
                "rule": "optional"
              },
              "x2Card": {
                "type": ".squareup.bills.CardData.X2Card",
                "id": 11,
                "rule": "optional"
              },
              "mcrCard": {
                "type": ".squareup.bills.CardData.MCRCard",
                "id": 12,
                "rule": "optional"
              },
              "t2Card": {
                "type": ".squareup.bills.CardData.T2Card",
                "id": 13,
                "rule": "optional"
              },
              "serverCompleted": {
                "type": ".squareup.bills.CardData.ServerCompleted",
                "id": 14,
                "rule": "optional"
              },
              "s3Card": {
                "type": ".squareup.bills.CardData.S3Card",
                "id": 15,
                "rule": "optional"
              },
              "t3Card": {
                "type": ".squareup.bills.CardData.T3Card",
                "id": 16,
                "rule": "optional"
              }
            },
            "nested": {
              "KeyedCard": {
                "fields": {
                  "cardNumber": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "expiry": {
                    "type": ".squareup.bills.CardData.KeyedCard.Expiry",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cvv": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "postalCode": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Expiry": {
                    "fields": {
                      "month": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "year": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "UnencryptedCard": {
                "fields": {
                  "track2Data": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "O1Card": {
                "fields": {
                  "encryptedSwipeData": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "S1Card": {
                "fields": {
                  "encryptedSwipeData": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "R4Card": {
                "fields": {
                  "encryptedSwipeData": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "R6Card": {
                "fields": {
                  "encryptedReaderData": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "optional"
                  },
                  "encryptedSwipeData": {
                    "type": "bytes",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "EncryptedKeyedCard": {
                "fields": {
                  "encryptedKeyedCardData": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "A10Card": {
                "fields": {
                  "encryptedReaderData": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "optional"
                  },
                  "entryMethod": {
                    "type": ".squareup.bills.CardData.A10Card.EntryMethod",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "EntryMethod": {
                    "values": {
                      "DEFAULT_DO_NOT_USE": 0,
                      "CONTACT": 1,
                      "CONTACTLESS": 2,
                      "SWIPED": 3
                    }
                  }
                }
              },
              "R12Card": {
                "fields": {
                  "encryptedReaderData": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "optional"
                  },
                  "encryptedFelicaData": {
                    "type": "bytes",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "X2Card": {
                "fields": {
                  "encryptedReaderData": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "optional"
                  },
                  "encryptedSwipeData": {
                    "type": "bytes",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "MCRCard": {
                "fields": {
                  "plaintextReaderData": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "optional"
                  },
                  "encryptedReaderData": {
                    "type": "bytes",
                    "id": 2,
                    "rule": "optional"
                  },
                  "encryptedPinData": {
                    "type": "bytes",
                    "id": 3,
                    "rule": "optional"
                  },
                  "encryptedReaderDataIv": {
                    "type": "bytes",
                    "id": 4,
                    "rule": "optional"
                  },
                  "encryptedPinDataIv": {
                    "type": "bytes",
                    "id": 5,
                    "rule": "optional"
                  },
                  "source": {
                    "type": ".squareup.bills.CardData.MCRCard.Source",
                    "id": 6,
                    "rule": "optional"
                  },
                  "pseudopan": {
                    "type": "bytes",
                    "id": 7,
                    "rule": "optional"
                  },
                  "hmacPin": {
                    "type": "bytes",
                    "id": 8,
                    "rule": "optional"
                  },
                  "hmacPan": {
                    "type": "bytes",
                    "id": 9,
                    "rule": "optional"
                  },
                  "sealedTicket": {
                    "type": "bytes",
                    "id": 10,
                    "rule": "optional"
                  },
                  "msNonce": {
                    "type": "int64",
                    "id": 11,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Source": {
                    "values": {
                      "MCR": 0,
                      "VCR": 1
                    }
                  }
                }
              },
              "T2Card": {
                "fields": {
                  "encryptedReaderData": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "optional"
                  },
                  "encryptedSwipeData": {
                    "type": "bytes",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "S3Card": {
                "fields": {
                  "encryptedReaderData": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "optional"
                  },
                  "encryptedSwipeData": {
                    "type": "bytes",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "T3Card": {
                "fields": {
                  "encryptedReaderData": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ServerCompleted": {
                "fields": {
                  "preauthIdempotencyKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "brand": {
                    "type": ".squareup.bills.CardData.ServerCompleted.ServerCompletedBrand",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ServerCompletedBrand": {
                    "values": {
                      "UNKNOWN_SERVER_COMPLETED_BRAND": 0,
                      "ALIPAY": 1,
                      "CASH_APP": 2,
                      "PAYPAY": 3,
                      "AFTERPAY": 4,
                      "RAKUTEN_PAY": 5,
                      "AU_PAY": 6,
                      "D_BARAI": 7,
                      "MERPAY": 8,
                      "WECHAT_PAY": 9
                    }
                  }
                }
              },
              "ReaderType": {
                "values": {
                  "UNKNOWN": 0,
                  "KEYED": 1,
                  "UNENCRYPTED": 2,
                  "O1": 3,
                  "S1": 4,
                  "R4": 5,
                  "R6": 6,
                  "ENCRYPTED_KEYED": 7,
                  "A10": 8,
                  "R12": 9,
                  "X2": 10,
                  "MCR": 11,
                  "T2": 12,
                  "SERVER_COMPLETED": 13,
                  "S3": 14,
                  "T3": 15,
                  "R41": 16,
                  "R42": 17
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bills?.nested?.CardData && !$root.nested?.squareup?.nested?.bills?.nested?.CardData?.nested?.KeyedCard && !$root.nested?.squareup?.nested?.bills?.nested?.CardData?.nested?.KeyedCard?.nested?.Expiry && !$root.nested?.squareup?.nested?.bills?.nested?.CardData?.nested?.UnencryptedCard && !$root.nested?.squareup?.nested?.bills?.nested?.CardData?.nested?.O1Card && !$root.nested?.squareup?.nested?.bills?.nested?.CardData?.nested?.S1Card && !$root.nested?.squareup?.nested?.bills?.nested?.CardData?.nested?.R4Card && !$root.nested?.squareup?.nested?.bills?.nested?.CardData?.nested?.R6Card && !$root.nested?.squareup?.nested?.bills?.nested?.CardData?.nested?.EncryptedKeyedCard && !$root.nested?.squareup?.nested?.bills?.nested?.CardData?.nested?.A10Card && !$root.nested?.squareup?.nested?.bills?.nested?.CardData?.nested?.A10Card?.nested?.EntryMethod && !$root.nested?.squareup?.nested?.bills?.nested?.CardData?.nested?.R12Card && !$root.nested?.squareup?.nested?.bills?.nested?.CardData?.nested?.X2Card && !$root.nested?.squareup?.nested?.bills?.nested?.CardData?.nested?.MCRCard && !$root.nested?.squareup?.nested?.bills?.nested?.CardData?.nested?.MCRCard?.nested?.Source && !$root.nested?.squareup?.nested?.bills?.nested?.CardData?.nested?.T2Card && !$root.nested?.squareup?.nested?.bills?.nested?.CardData?.nested?.S3Card && !$root.nested?.squareup?.nested?.bills?.nested?.CardData?.nested?.T3Card && !$root.nested?.squareup?.nested?.bills?.nested?.CardData?.nested?.ServerCompleted && !$root.nested?.squareup?.nested?.bills?.nested?.CardData?.nested?.ServerCompleted?.nested?.ServerCompletedBrand && !$root.nested?.squareup?.nested?.bills?.nested?.CardData?.nested?.ReaderType) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CardData @ squareup/bills/card_data.proto at 11:1
 */
export const CardData = $root.lookupType('squareup.bills.CardData');
fixType(CardData);
Builder.createAndAttachToType(CardData);
/**
 * SOURCE KeyedCard @ squareup/bills/card_data.proto at 12:3
 */
CardData.KeyedCard = $root.lookupType('squareup.bills.CardData.KeyedCard');
fixType(CardData.KeyedCard);
Builder.createAndAttachToType(CardData.KeyedCard);
/**
 * SOURCE Expiry @ squareup/bills/card_data.proto at 15:5
 */
CardData.KeyedCard.Expiry = $root.lookupType('squareup.bills.CardData.KeyedCard.Expiry');
fixType(CardData.KeyedCard.Expiry);
Builder.createAndAttachToType(CardData.KeyedCard.Expiry);
/**
 * SOURCE UnencryptedCard @ squareup/bills/card_data.proto at 27:3
 */
CardData.UnencryptedCard = $root.lookupType('squareup.bills.CardData.UnencryptedCard');
fixType(CardData.UnencryptedCard);
Builder.createAndAttachToType(CardData.UnencryptedCard);
/**
 * SOURCE O1Card @ squareup/bills/card_data.proto at 32:3
 */
CardData.O1Card = $root.lookupType('squareup.bills.CardData.O1Card');
fixType(CardData.O1Card);
Builder.createAndAttachToType(CardData.O1Card);
/**
 * SOURCE S1Card @ squareup/bills/card_data.proto at 37:3
 */
CardData.S1Card = $root.lookupType('squareup.bills.CardData.S1Card');
fixType(CardData.S1Card);
Builder.createAndAttachToType(CardData.S1Card);
/**
 * SOURCE R4Card @ squareup/bills/card_data.proto at 42:3
 */
CardData.R4Card = $root.lookupType('squareup.bills.CardData.R4Card');
fixType(CardData.R4Card);
Builder.createAndAttachToType(CardData.R4Card);
/**
 * SOURCE R6Card @ squareup/bills/card_data.proto at 57:3
 */
CardData.R6Card = $root.lookupType('squareup.bills.CardData.R6Card');
fixType(CardData.R6Card);
Builder.createAndAttachToType(CardData.R6Card);
/**
 * SOURCE EncryptedKeyedCard @ squareup/bills/card_data.proto at 65:3
 */
CardData.EncryptedKeyedCard = $root.lookupType('squareup.bills.CardData.EncryptedKeyedCard');
fixType(CardData.EncryptedKeyedCard);
Builder.createAndAttachToType(CardData.EncryptedKeyedCard);
/**
 * SOURCE A10Card @ squareup/bills/card_data.proto at 69:3
 */
CardData.A10Card = $root.lookupType('squareup.bills.CardData.A10Card');
fixType(CardData.A10Card, {
  entryMethod: {
    required: true
  }
});
Builder.createAndAttachToType(CardData.A10Card);
/**
 * How a card was presented to A10 - dip, tap, or swipe.
 *
 * SOURCE EntryMethod @ squareup/bills/card_data.proto at 76:5
 */
CardData.A10Card.EntryMethod = $root.lookupEnum('squareup.bills.CardData.A10Card.EntryMethod').values;
/**
 * SOURCE R12Card @ squareup/bills/card_data.proto at 87:3
 */
CardData.R12Card = $root.lookupType('squareup.bills.CardData.R12Card');
fixType(CardData.R12Card);
Builder.createAndAttachToType(CardData.R12Card);
/**
 * SOURCE X2Card @ squareup/bills/card_data.proto at 95:3
 */
CardData.X2Card = $root.lookupType('squareup.bills.CardData.X2Card');
fixType(CardData.X2Card);
Builder.createAndAttachToType(CardData.X2Card);
/**
 * SOURCE MCRCard @ squareup/bills/card_data.proto at 103:3
 */
CardData.MCRCard = $root.lookupType('squareup.bills.CardData.MCRCard');
fixType(CardData.MCRCard);
Builder.createAndAttachToType(CardData.MCRCard);
/**
 * SOURCE Source @ squareup/bills/card_data.proto at 122:5
 */
CardData.MCRCard.Source = $root.lookupEnum('squareup.bills.CardData.MCRCard.Source').values;
/**
 * SOURCE T2Card @ squareup/bills/card_data.proto at 146:3
 */
CardData.T2Card = $root.lookupType('squareup.bills.CardData.T2Card');
fixType(CardData.T2Card);
Builder.createAndAttachToType(CardData.T2Card);
/**
 * SOURCE S3Card @ squareup/bills/card_data.proto at 154:3
 */
CardData.S3Card = $root.lookupType('squareup.bills.CardData.S3Card');
fixType(CardData.S3Card);
Builder.createAndAttachToType(CardData.S3Card);
/**
 * SOURCE T3Card @ squareup/bills/card_data.proto at 162:3
 */
CardData.T3Card = $root.lookupType('squareup.bills.CardData.T3Card');
fixType(CardData.T3Card);
Builder.createAndAttachToType(CardData.T3Card);
/**
 * Placeholder for server-completed tenders. Info about the payer will be filled in on the server.
 *
 * SOURCE ServerCompleted @ squareup/bills/card_data.proto at 168:3
 */
CardData.ServerCompleted = $root.lookupType('squareup.bills.CardData.ServerCompleted');
fixType(CardData.ServerCompleted);
Builder.createAndAttachToType(CardData.ServerCompleted);
/**
 * SOURCE ServerCompletedBrand @ squareup/bills/card_data.proto at 169:5
 */
CardData.ServerCompleted.ServerCompletedBrand = $root.lookupEnum('squareup.bills.CardData.ServerCompleted.ServerCompletedBrand').values;
/**
 * SOURCE ReaderType @ squareup/bills/card_data.proto at 188:3
 */
CardData.ReaderType = $root.lookupEnum('squareup.bills.CardData.ReaderType').values;